/* eslint-disable */
import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { MagicApronAssistant } from '@thd-olt-component-react/magic-apron';

export const Assistant = () => {
  return (
    <QueryProvider cacheKey="magic-apron-header">
      <ErrorBoundary name="magic-apron-assistant-in-header">
        <div className="sui-h-screen">
          <MagicApronAssistant withPortal={false} force />
        </div>
      </ErrorBoundary>
    </QueryProvider>
  );
};

Assistant.propTypes = {
};

Assistant.displayName = 'AssistantPage';
